import { SEGMENT_NAME_MAX } from "#shared/segmentsTypes.ts";

export interface ValidateSegmentNameMessages {
    required: string;
    tooLong: string;
}

export function validateSegmentName(name: string, messages: ValidateSegmentNameMessages): string | undefined {
    const trimmed = name.trim();

    if (!trimmed) {
        return messages.required;
    }

    return trimmed.length > SEGMENT_NAME_MAX ? messages.tooLong : undefined;
}
